
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"14","height":"11","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1 2l6.057 6L13 2.113","stroke":"#F7941E","stroke-width":"3","fill":"none","fill-rule":"evenodd"}})])
      }
    
      }
    